export default __webpack_public_path__ + "static/media/wait.3e4f5446.gif";